import React, { FC, ReactElement } from "react";
import { Text } from "../components/Text";
import { makeStyles, Box } from "@material-ui/core";

interface ISlideProps {
  text: string;
  svg: ReactElement;
}

export const Slide: FC<ISlideProps> = ({ text, svg }) => {
  const classes = styles();

  return (
    <Box className={classes.slideContainer}>
      <Box className={classes.image}>{svg}</Box>
      <Text className={classes.text}>{text}</Text>
    </Box>
  );
};

const styles = makeStyles(() => ({
  slideContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 350,
    maxWidth: 300,
  },
  image: {
    marginBottom: 40,
  },
  text: {
    textAlign: "center",
  },
}));
